import ImageWIthSignedUrl from "components/S3Utility/ImageWIthSignedUrl";
import { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import ReactQuill from "react-quill";
import { useSearchParams } from "react-router-dom";
import MProductDetails from "./MProductDetails";
import MWoProductSizes from "./MWoProductSizes";
import { GetNameWithTimeStamp } from "utils/UtilityFuncs";
import API from "services/axios";
import authHeader from "services/auth-header";
import Spinner from "components/Spinner";
import { useDispatch } from "react-redux";
import { setNotification } from "features/Notification/notificationSlice";

export default function MWoAddUpdateProduct({
  MOProducts,
  selectedMWo,
  isUpdateMode,
  productTypes,
  fabrics,
  showModal,
  refreshFunc,
  isViewOnly = false,
}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  /*   All States
   ********************************************* */
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [formData, setFormData] = useState({});
  const [previewImage, setPreviewImage] = useState(null);

  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
      ["clean"],
    ],
  };

  const [loading, setLoading] = useState(false);

  /*   All Functions
   ********************************************* */
  const loadingOn = () => {
    setLoading(true);
  };

  const loadingOff = () => {
    setLoading(false);
  };

  const prevProduct = () => {
    setPreviewImage(null);
    let currProductId = selectedProduct?.m_productId;
    let checkCrrIdExists = MOProducts?.find(
      (item) => item?.m_productId === parseInt(currProductId)
    );
    if (!checkCrrIdExists) {
      return;
    }
    let currentIndex = MOProducts?.indexOf(selectedProduct);
    if (currentIndex === 0) {
      return;
    }

    setSearchParams((prev) => {
      let _selectedTab = prev.get("selected-tab");
      return {
        ...prev,
        "selected-tab": _selectedTab,
        m_productId: MOProducts[currentIndex - 1]?.m_productId,
      };
    });
  };

  const nextProduct = () => {
    setPreviewImage(null);

    let currProductId = selectedProduct?.m_productId;
    let checkCrrIdExists = MOProducts?.find(
      (item) => item?.m_productId === parseInt(currProductId)
    );
    if (!checkCrrIdExists) {
      return;
    }
    let currentIndex = MOProducts?.indexOf(selectedProduct);
    if (currentIndex === MOProducts.length - 1) {
      return;
    }
    setSearchParams((prev) => {
      let _selectedTab = prev.get("selected-tab");
      return {
        ...prev,
        "selected-tab": _selectedTab,
        m_productId: MOProducts[currentIndex + 1]?.m_productId,
      };
    });
  };

  const getBase64Image = async (e) => {
    const file = e.target.files[0];

    // const MAX_FILE_SIZE = 300 * 1024; // 800 KB in bytes
    // if (!["image/jpeg", "image/png"].includes(file.type)) {
    //   alert("Only JPG and PNG image files are allowed.");
    //   e.target.value = "";
    //   return;
    // }
    // if (file.size > MAX_FILE_SIZE) {
    //   alert(`File size exceeds limit (300 KB). Please select a smaller file.`);
    //   e.target.value = "";
    //   return;
    // }

    setFormData((prev) => {
      return { ...prev, file };
    });
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setPreviewImage(reader?.result);
    };
  };

  const updateFormData = (data) => {
    let totalQuantity = 0;
    let totalPrice = 0;

    data.map((item) => {
      totalPrice +=
        parseFloat(item.price).toFixed(2) *
        parseFloat(item.quantity).toFixed(2);
      totalQuantity += parseInt(item.quantity);
    });
    let updatedFormData = {
      ...formData,
      productSizes: JSON.stringify(data),
      totalPrice,
      totalQuantity,
    };
    setFormData(updatedFormData);
    return updatedFormData;
  };

  const addProduct = async (e) => {
    e.preventDefault();
    if (formData?.productType === "") {
      alert("Please select product type");
      return;
    }
    loadingOn();
    try {
      let addData = new FormData();
      let bodyData = {
        ...formData,
        m_woId: selectedMWo?.m_woId,
        productWageId:
          typeof formData?.productWageId === "string"
            ? Number(formData?.productWageId)
            : formData?.productWageId,
      };

      //Appending File if present.
      if (formData?.file) {
        let file = formData?.file;
        addData.append("file", file);
        let folder = `kms/manufacturer/wo/${selectedMWo?.m_woId}/products`;
        addData.append("folder", folder);
        // Creating filePath of upload folder to save it to database
        let fileName = GetNameWithTimeStamp(file.name);
        let productImage = `${folder}/${fileName}`;
        addData.append("fileName", fileName);
        bodyData.productImage = productImage;
      }

      // Assigning update data to formData in JSON string
      addData.append("data", JSON.stringify(bodyData));

      const { data } = await API.post(`/m-order/products`, addData, {
        headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
      });

      if (data?.success) {
        await refreshFunc(selectedMWo?.m_woId);
        setFormData({});
        showModal(false);
        loadingOff();
        return;
      } else {
        dispatch(
          setNotification({
            message: data.message || "Failed to add product",
            type: "error",
          })
        );
      }
      loadingOff();
    } catch (err) {
      alert(err.message);
      loadingOff();
    }
  };

  const updateProduct = async (e) => {
    e.preventDefault();

    loadingOn();

    if (formData?.productType === "") {
      alert("Please select product type");
      return;
    }
    try {
      let updateData = new FormData();
      let bodyData = {
        ...formData,
        id: formData?.id,
        productWageId:
          typeof formData?.productWageId === "string"
            ? Number(formData?.productWageId)
            : formData?.productWageId,
      };

      console.log("bodyData", bodyData);

      //Appending File if present.
      if (formData?.file) {
        let file = formData?.file;
        updateData.append("file", file);
        let folder = `kms/manufacturer/wo/${selectedMWo?.m_woId}/products`;
        updateData.append("folder", folder);
        // Creating filePath of upload folder to save it to database
        let fileName = GetNameWithTimeStamp(file.name);
        let productImage = `${folder}/${fileName}`;
        bodyData.productImage = productImage;
        updateData.append("fileName", fileName);
      }

      // Assigning update data to formData in JSON string
      updateData.append("data", JSON.stringify(bodyData));

      const { data } = await API.patch(`/m-wo-products`, updateData, {
        headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
      });
      if (data.success) {
        await refreshFunc(selectedMWo?.m_woId);
        showModal(false);
        loadingOff();
        return;
      } else {
        dispatch(
          setNotification({
            message: data.message || "Failed to update product",
            type: "error",
          })
        );
        loadingOff();
        return;
      }
    } catch (err) {
      if (err?.response?.status === 413) {
        alert("Size Too Large");
        loadingOff();
        return;
      }
      dispatch(
        setNotification({
          message: err.message || "Failed to update product",
          type: "error",
        })
      );
      loadingOff();
      return;
    }
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    const m_productId = searchParams.get("m_productId");

    if (m_productId) {
      const product = MOProducts?.find(
        (product) => product?.m_productId === parseInt(m_productId)
      );
      setSelectedProduct((prev) => product);
      if (isUpdateMode) {
        setFormData((prev) => null);
      }
    } else {
      setSelectedProduct(null);
      setFormData({});
    }
  }, [searchParams, isUpdateMode, MOProducts]);

  useEffect(() => {
    if (isUpdateMode && selectedProduct) {
      let _formData = {
        ...selectedProduct,
      };

      setFormData((prev) => _formData);
    } else {
      setFormData({});
    }
  }, [isUpdateMode, selectedProduct]);

  return (
    <>
      <Modal.Body className="py-0">
        <div className="d-flex justify-content-between align-items-center px-3 pt-2 py-1 mb-2 border-bottom border-2">
          <div className="fs-4">
            <h3>
              {isUpdateMode ? "Update Product" : "Add Product"}{" "}
              {selectedProduct?.productType || ""}
            </h3>
          </div>
          <div className="d-flex justify-content-end align-items-center ">
            <button
              onClick={() => {
                prevProduct();
              }}
              className={"btn btn-success btn-sm p-0 px-1 mx-1"}
            >
              <i className="mdi mdi-arrow-left-bold fs-3 py-0 my-0"></i>
            </button>
            <button
              onClick={() => {
                nextProduct();
              }}
              className={"btn btn-success btn-sm p-0 px-1 me-1"}
            >
              <i className="mdi mdi-arrow-right-bold fs-3 py-0 my-0"></i>
            </button>
            <button
              onClick={() => {
                showModal(false);
              }}
              className={"btn btn-danger me-1"}
            >
              BACK
            </button>
            <Dropdown>
              <Dropdown.Toggle
                variant="primary"
                className="no-icon px-1"
                id="dropdown-basic"
              >
                <i className="mdi mdi-dots-vertical "></i>
              </Dropdown.Toggle>

              <Dropdown.Menu className="w-25">
                <Dropdown.Item as="div" className="">
                  Drop Down Item
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        <div>
          {loading && <Spinner />}
          {/* {JSON.stringify(formData?.productImage)} */}

          {/* Bottom Row Image + Notes */}
          <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
            {/* Product Details */}
            <div className="w-50 px-2 py-2 rounded-3 bg-white shadow-sm">
              <MProductDetails
                productTypes={productTypes}
                fabrics={fabrics}
                formData={formData}
                setFormData={setFormData}
                setSelectedProduct={setSelectedProduct}
              />
            </div>
            {/*  Product Sizes */}
            <div className="w-50 px-2 rounded-3 bg-white shadow-sm">
              <MWoProductSizes
                updateFormData={updateFormData}
                formData={formData}
                updateFunc={updateProduct}
                isViewOnly={isViewOnly}
                selectedProduct={selectedProduct}
              />
            </div>
          </div>
          {/* Bottom Row Image + Notes */}
          <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
            <div
              className="w-50 px-2 py-2 rounded-3 bg-white shadow-sm "
              style={{ borderRadius: 15, height: 365 }}
            >
              {/*   Image select
               ********************************************* */}
              <div className="d-flex flex-column justify-content-between h-100">
                <div className="h-100">
                  {formData?.productImage && !previewImage ? (
                    <ImageWIthSignedUrl
                      imgStyle={{
                        width: 600,
                        height: 300,
                      }}
                      imgClasses="mb-2"
                      path={formData?.productImage}
                      alt="Image"
                    />
                  ) : !formData?.productImage && previewImage ? (
                    <img
                      width={520}
                      height={300}
                      src={previewImage}
                      className=""
                      alt="preview"
                    />
                  ) : (
                    <>
                      {!previewImage && (
                        <div className="fs-3 text-muted flex-center h-100">
                          NO Image Selected
                        </div>
                      )}
                    </>
                  )}
                </div>

                <div className="w-100">
                  {formData?.productImage ? (
                    <button
                      onClick={() => {
                        setPreviewImage(null);
                        setFormData((prev) => {
                          return { ...prev, productImage: null };
                        });
                      }}
                      type="button"
                      disabled={isViewOnly}
                      className="btn btn-sm btn-danger w-100"
                    >
                      Delete Image
                    </button>
                  ) : (
                    <div className="bg-warning">
                      <input
                        onChange={getBase64Image}
                        type="file"
                        className="form-control w-100"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="w-50 px-2 py-2 rounded-3 bg-white shadow-sm"
              style={{ borderRadius: 15, height: 366 }}
            >
              {/*   Notes
               ********************************************* */}
              <div className="">
                <ReactQuill
                  modules={modules}
                  theme="snow"
                  value={formData?.notes}
                  onChange={(val) => setFormData({ ...formData, notes: val })}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-secondary"
          onClick={() => {
            showModal(false);
          }}
        >
          Close
        </button>
        <button
          className="btn btn-primary"
          onClick={isUpdateMode ? updateProduct : addProduct}
        >
          {isUpdateMode ? "Update Product" : "Add Product"}
        </button>
      </Modal.Footer>
    </>
  );
}
